/* eslint-disable */
import { AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS } from '../Auth.types';

/**
 * Attempt to login a user and fire the appropriate actions
 * @param {any} response The auth success response
 * @param {any} tokenManager The token manager
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS>>} The created `Action`
 */
const authLoginSuccess = (response, tokenManager) => ({ authService, fromPromise }) => {
  const promise = authService.loginSuccess(response, tokenManager);
  return fromPromise(promise, {}, [AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS]);
};

export default authLoginSuccess;
